import { render, staticRenderFns } from "./InternalMessages.vue?vue&type=template&id=f08b6b7c&scoped=true"
import script from "./InternalMessages.vue?vue&type=script&lang=js"
export * from "./InternalMessages.vue?vue&type=script&lang=js"
import style0 from "./InternalMessages.vue?vue&type=style&index=0&id=f08b6b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08b6b7c",
  null
  
)

export default component.exports